// extracted by mini-css-extract-plugin
module.exports = {"dash":"inheritance_dash__3eiHa"};